module.exports = __webpack_public_path__ + "static/media/healiary_application.bef67ea2.svg";